/** Types ERP du workflow transfert entrepôts (gestion stock). */
export const STOCK_TRANSFER_WORKFLOW_TYPE_IDS = {
    BON_SORTIE: 9,
    BON_RECEPTION: 13,
    BON_TRANSFERT: 16,
    PV_ECART: 20
} as const;

export type StockTransferWorkflowStep =
    | 'TRANSFERT_ENTREPOT'
    | 'BON_TRANSFERT'
    | 'BON_SORTIE'
    | 'EN_CIRCULATION'
    | 'BON_RECEPTION'
    | 'SOLDE'
    | 'PV_ECART';
